var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgNoPushpin = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.21895 1.12435L9.21862 1.12403H9.21928L9.21895 1.12435ZM11.311 9.40305L13.4613 7.25268L13.9326 7.72403L14.8759 6.78135L9.21895 1.12435L8.27662 2.06735L8.74795 2.53868L6.53611 4.75052L7.49078 5.68072L9.69062 3.48135L12.5186 6.31002L10.3558 8.47235L11.311 9.40305ZM10.5457 10.519L9.41286 9.41512L9.40462 9.42335L9.02862 11.3048L4.69528 6.97135L6.52834 6.60435L5.37084 5.47645L3.56195 5.83802L2.61928 6.78135L5.44795 9.60935L2.14795 12.9093L3.09062 13.852L6.39062 10.552L9.21862 13.3807L10.1619 12.438L10.5457 10.519Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76664 1.26572L3.82397 2.20838L14.6186 12.727L15.5613 11.7837L4.76664 1.26572Z"
  }))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgNoPushpin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/no-pushpin.0bd9f027cef4fb4bd75f5694346fcb22.svg";